import { useEffect } from 'react';

import useRequestCallback from './useRequestCallback';

export function useEffectRequestCallback(logic, onFailure) {
  const {
    loading,
    callback,
    requestInstance,
  } = useRequestCallback(logic, onFailure, true);

  useEffect(() => {
    callback();
    return () => {
      requestInstance.abort();
    };
  }, [callback, requestInstance]);

  return {
    loading,
    callback,
    requestInstance,
  };
}

export default useEffectRequestCallback;
